import VehicleCluster from 'models/VehicleCluster'

const mapGroupedCoveragesToClusterArray = (coverages = []) =>
    coverages.flatMap(({ insuranceCompany, items = [] }) =>
        items.map((item) => VehicleCluster.fromGroupedCoverageItem(insuranceCompany, item))
    )

export default mapGroupedCoveragesToClusterArray
